import React from 'react';

export default function SkeletonCard() {
  return (
    <div className="card-skeleton">
      <div className="card-skeleton-img skeleton" />
      <div className="card-skeleton-body">
        <div className="card-skeleton-title skeleton" />
        <div className="card-skeleton-price skeleton" />
        <div className="card-skeleton-meta skeleton" />
        <div className="card-skeleton-badge skeleton" />
      </div>
    </div>
  );
}
